export const GROWTHBOOK_API_HOST = import.meta.env.VITE_GROWTHBOOK_API_HOST;
export const GROWTHBOOK_CLIENT_KEY_PROD = import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY_PROD;
export const GROWTHBOOK_CLIENT_KEY_DEV = import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY_DEV;
